import classNames from 'classnames';
import React, { ReactNode } from 'react';

import { ErrorMessage, InfoMessage, SuccessMessage, WarningMessage } from '@eika/attention-message';
import { IconTypes } from '@eika/icon';
import { Link } from '@eika/link';

import { useConfig } from '../../config';
import { AttentionMessageType } from '../../types/generated-types';
import { LinkItem } from '../link-item/link-item-types';
import { getUrl } from '../link-item/link-item-utils';

import './attention-message.scss';

type AttentionMessageTypeProps = {
    type: AttentionMessageType;
    attentionMessageAttributes: {
        id: string;
        text: React.ReactNode;
        icon: IconTypes;
        clickableItem: React.JSX.Element;
    };
};

const AttentionMessageType2 = ({ type, attentionMessageAttributes }: AttentionMessageTypeProps) => {
    switch (type) {
        case AttentionMessageType.Warning:
            return <WarningMessage {...attentionMessageAttributes} />;
        case AttentionMessageType.Error:
            return <ErrorMessage {...attentionMessageAttributes} />;
        case AttentionMessageType.Success:
            return <SuccessMessage {...attentionMessageAttributes} />;
        case AttentionMessageType.Info:
        default: {
            return <InfoMessage {...attentionMessageAttributes} />;
        }
    }
};

interface AttentionMessageProps {
    id: string;
    text: ReactNode | string;
    type: AttentionMessageType;
    icon?: IconTypes;
    linkItem?: LinkItem;
    tittel?: string;
}

export const AttentionMessage = ({ text, type, icon, linkItem, id, tittel }: AttentionMessageProps) => {
    const { minside, glasskadeverksted } = useConfig().links;

    if (type === AttentionMessageType.Text || type === AttentionMessageType.SubHeading) {
        return (
            <div
                className={classNames('container__standard-width container__standard-width__attention-message_text', {
                    'attention-message__sub-title': tittel && text === '',
                })}
            >
                {tittel && <h3 className="attention-message__title typography-subtitle">{tittel}</h3>}
                {text !== '' && <p className="attention-message__text">{text}</p>}
            </div>
        );
    }

    const attentionMessageAttributes = {
        id,
        text,
        icon,
        clickableItem: linkItem && (
            <Link
                href={getUrl(linkItem, minside.url, glasskadeverksted.url)}
                linkType={linkItem.linkType}
                target={linkItem.link.urlType === 'ExternalLink' ? '_blank' : '_self'}
            >
                {linkItem.tekst}
            </Link>
        ),
    };

    return (
        <div className="container__standard-width container__standard-width__attention-message">
            <AttentionMessageType2 type={type} attentionMessageAttributes={attentionMessageAttributes} />
        </div>
    );
};
